import { Box, Flex, Icon, Stack } from '@chakra-ui/react';
import { Divider, Text } from '@diamond/shared/ui';
import { buyerCurrencyFormatter } from '@diamond/shared/utils';
import { CreditCard } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';

export function PaymentSummary() {
  const { getValues } = useFormContext();

  return (
    <Box
      flex="1"
      border="1px"
      borderColor="gray.33"
      shadow="base"
      px="4"
      py="6"
      rounded="lg"
    >
      <Flex>
        <Flex justifyContent="center" alignItems="center" gap="2">
          <Icon as={CreditCard} color="blue" boxSize={8} />
          <Text fontSize="20px" fontWeight="bold">
            Ringkasan Pembayaran
          </Text>
        </Flex>
      </Flex>
      <Flex justifyContent="end" gap="2">
        {getValues('saved_total') !== 0 && (
          <>
            <Text fontSize="sm" textDecor="line-through" color="gray.75">
              {buyerCurrencyFormatter(getValues('original_total'))}
            </Text>

            <Text fontWeight="bold" fontSize="sm" color="red">
              {`Hemat ${buyerCurrencyFormatter(getValues('saved_total'))}`}
            </Text>
          </>
        )}
      </Flex>
      <Divider height="1px" mb="6" />
      <Flex
        justifyContent={{ base: 'flex-start', md: 'flex-end' }}
        alignItems="center"
        mr="2"
      >
        <Stack direction={{ base: 'column', md: 'row' }} alignItems="baseline">
          <Text fontWeight="bold" fontSize="lg" mr="2" mt="2" color="gray.75">
            Total Tagihan
          </Text>
          <Text fontWeight="bold" fontSize={{ base: '2xl', md: '4xl' }}>
            {buyerCurrencyFormatter(getValues('total'))}
          </Text>
        </Stack>
      </Flex>
    </Box>
  );
}
